import React, { FC, ReactNode } from 'react';
import { useConfig } from '../../../../../selectors';
import { getCldImageSizeTransformation, getCldImageUrl } from '../../../../../utils';
import { SMALL_SELECTABLES_ITEM_CONTENT_WIDTH, SMALL_SELECTABLES_ITEM_CONTENT_HEIGHT } from '../containers/SmallSelectabes';

export const LOGO_WIDTH = SMALL_SELECTABLES_ITEM_CONTENT_WIDTH;
export const LOGO_HEIGHT = SMALL_SELECTABLES_ITEM_CONTENT_HEIGHT;
const imgSizeTransformation = `${getCldImageSizeTransformation(LOGO_WIDTH, LOGO_HEIGHT)},c_fit`;

export interface LogoProps {
  publicId: string,
  children: (logoSrc: string) => ReactNode;
}

export const Logo: FC<LogoProps> = ({ children, publicId }) => {
  const config = useConfig();
  const logoSrc = getCldImageUrl(config.cloudName, imgSizeTransformation, publicId);

  return <>
    {children(logoSrc)}
  </>;
};
